import styled from "@emotion/styled";
import { Box, Card } from "@mui/material";

export const NenhumComportamentoContainer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    min-height: 120px;
    gap: 0.5rem;
    padding: 1.5rem;
    border: 1px dashed ${props => props.theme.palette.divider};
    border-radius: 12px;
`

export const ComportamentosContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`

export const ComportamentoCard = styled(Card)`
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    border-radius: 12px;
`

export const TituloComportamentoContainer = styled(Box)`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
`
